import { Component } from "react";
import { Nav } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import ChevronListItem from "@/components/react/ChevronListItem";
import * as t from "@/lib/backend/manufacturing2.generated.types";

type Props = {
    filter: string;
    selected: t.IProcessData | null;
    processes: t.IProcessData[];
    handleProcessClick: (process: t.IProcessData) => void;
};

class ProcessesList extends Component<Props> {
    handleProcessClick(process: t.IProcessData) {
        // Ignore clicks for currently selected item.
        if (process === this.props.selected) {
            return;
        }

        // Handle click in parent
        this.props.handleProcessClick(process);
    }

    includes(needle: string, obj: t.IProcessData): boolean {
        needle = needle.toLowerCase();
        if (needle.length === 0) return true;
        if ("bottleneck".indexOf(needle) > -1) {
            if (obj.bottleneck === true) return true;
        }
        if (obj.title.toLowerCase().indexOf(needle) > -1) return true;
        if (obj.material_title.toLowerCase().indexOf(needle) > -1) return true;
        if (obj.material_uuid.toLowerCase().indexOf(needle) > -1) return true;
        return false;
    }

    render() {
        const processesList = this.props.processes.map(process => {
            const is_active = this.props.selected === process;
            const isBottleNeck = process.bottleneck;

            if (!this.includes(this.props.filter, process)) return null;
            return (
                <ChevronListItem
                    key={process.uuid}
                    text={
                        <>
                            <div className="title">
                                <dt>{process.title}</dt>
                                <dd>{process.material_title}</dd>
                            </div>
                            {isBottleNeck && (
                                <div className="badge badge-danger">
                                    <FormattedMessage
                                        id="Manufacturing.Processes.bottleneck"
                                        defaultMessage="bottleneck"
                                    />
                                </div>
                            )}
                        </>
                    }
                    onClick={() => this.handleProcessClick(process)}
                    is_active={is_active}
                />
            );
        });

        return (
            <Nav variant="tabs">
                <div className="nav-tabs-parent">{processesList}</div>
            </Nav>
        );
    }
}

export default ProcessesList;
